<template>
    <div>
        <h6 class="text-justify text-small">
            <span>By {{ buttonThatAgreesText }} you are agreeing to the&nbsp;</span>
            <span class="link-underline" @click="openPage(eventUrl + '/terms-of-use#EventTermsAndConditions')">Event</span>
            &amp;
            <span class="link-underline" @click="openPage(eventUrl + '/terms-of-use#SiteTermsAndConditions')">Site</span>
            <span>&nbsp;Terms & Conditions,&nbsp;</span>
            <span class="link-underline" @click="openPage(eventUrl + '/privacy-policy')">Privacy</span>&nbsp;&
            <span class="link-underline" @click="openPage(eventUrl + '/data-collection-policy')">Data Collection</span>
            <span>&nbsp;Policies</span>
        </h6>
    </div>
</template>

<script>
import store from '../../store/store';

export default {
    props: {
        buttonThatAgreesText: {
            type: String,
            default: ''
        }
    },

    data() {
      return {
        store,
      }
    },

    methods: {
        openPage: function(url) {
            window.open(url, '_blank');
        }
    },

    computed: {
        eventUrl: {
            get: function() {
                return (this.store.state.selected_event.EventUrl).replace(/\/$/, '');
            }
        }
    }

}
</script>

<style scoped>
h6 span {
    font-size: inherit;
}
.link-underline {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: #999;
}

.cursor-pointer {
    cursor: pointer;
}

</style>